import { API } from "utils/api";

const api = new API();

const refreshToken = () => {
  api.refreshToken();
};

export { refreshToken };
